import React from 'react';
import styled from '@emotion/styled';

import { TRowData } from 'types/rowDefs';

/* ======================================== */

const iconSize = 22;        // TODO theme
const iconMargin = 8;

const StyledButton = styled.button(
    () => ({
        width: iconSize + iconMargin * 2,
        height: '100%',
        padding: 0,
        margin: 0,
        marginBottom: -2,
        paddingLeft: iconMargin,
        paddingRight: iconMargin,
        borderWidth: 0,
        borderRightWidth: 2,
        borderStyle: 'solid',
        borderColor: '#E3E3E3',
        backgroundColor: 'transparent',

        cursor: 'pointer',
        fill: '#414141',        // TODO theme

        '&:last-of-type': {
            borderRightColor: 'transparent'
        },

        '&:disabled': {
            fill: '#41414155',  // TODO theme
            cursor: 'default'
        }
    })
);

/* ======================================== */

type TProps = {
    disabled: boolean;
    callback?: (rowData: TRowData) => void | undefined;
    rowData?: TRowData;
    icon: SvgrComponent;
}

const handleCallback = (
    callback: (rowData: TRowData) => void | undefined,
    rowData: TRowData
) => (evt: React.MouseEvent<HTMLButtonElement>) => {
    callback(rowData);
    evt.stopPropagation();
};

/* ======================================== */

/**
 * @private
 */
export const ActionsButton: React.FC<TProps> = (props) => {
    const { disabled, callback, rowData } = props;
    const Icon = props.icon;

    if (callback && rowData) {
        return (
            <StyledButton
                disabled={disabled}
                onClick={handleCallback(callback, rowData)}
            >
                <Icon />
            </StyledButton>
        );
    }
    return null;
};
